/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {

    declare var contentPageModelSelf: ContentPageModel;

    export class ContentPageModel{
        public contentPage: Wars.Domain.Model.Dtos.ContentPageDto;
        public editableContentPageDto: Wars.Domain.Model.Dtos.EditableContentPageDto;

        constructor(
            private contentPageService: services.ContentPageService,
            private editableContentPageService: warsApp.services.EditableContentPageService,
            private growlService: angular.growl.IGrowlService,
            private id: string) {
            contentPageModelSelf = this;

            //if content page is editable go get the editable version (security checks are performed on server)
            contentPageService.getContentPageForExecution(id).then(p => {
                if (!p.isEditable) {
                    contentPageModelSelf.contentPage = p;
                } else {
                    editableContentPageService.getEditableContentPageForView(id)
                        .then(ep => {
                            contentPageModelSelf.editableContentPageDto = ep;
                        });
                }
            });
        }
    }
}